var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.182 3.5H6.68201C4.47287 3.5 2.68201 5.29086 2.68201 7.5V16.5C2.68201 18.7091 4.47287 20.5 6.68201 20.5H17.182C19.3911 20.5 21.182 18.7091 21.182 16.5V7.5C21.182 5.29086 19.3911 3.5 17.182 3.5Z",
    stroke: "#25AE35",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.729 7.58984L9.934 11.7198C10.5376 12.0706 11.2234 12.2553 11.9215 12.2553C12.6197 12.2553 13.3054 12.0706 13.909 11.7198L21.134 7.58984",
    stroke: "#25AE35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7a52bb804c3cb2ae38cd993ce8563cd8.svg";
export { ForwardRef as ReactComponent };